import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';

import { RedirectGuard } from './shared/guards/redirect.guard';
import { CustomUrlSerializer } from './services/custom-url-serializer';
import { NewJoineeApplicationComponent } from './components/new-joinee-application/new-joinee-application.component';
import { ViewApplicationComponent } from './components/view-application/view-application.component';
import { LoginComponent } from './components/login/login.component';
import { SelectedCandidateDetailFormComponent } from './components/selected-candidate-detail-form/selected-candidate-detail-form.component';


const routes: Routes = [
  {
    path: '',
    component: NewJoineeApplicationComponent
  
  
  },
  // {
  //   path: 'login',
  //   component: LoginComponent
  
  
  // },
  // {
  //   path: 'new-joinee-application',
  //   component: NewJoineeApplicationComponent
  // },
  // {
  //   path: 'view-application',
  //   component: ViewApplicationComponent
  // },
  {
    path: '**',
    component: NewJoineeApplicationComponent
  },

  
  

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: UrlSerializer,
      useClass: CustomUrlSerializer
    }
  ],
})
export class AppRoutingModule { }
